<div class="p-field" *ngIf="formControl">
  <label for="taxAuthorityId">{{ 'TaxAuthority'|translate }}<span class="required" *ngIf="required">*</span></label>
  <p-dropdown id="taxAuthorityId" [options]="taxAuthorities" [filter]="true" [formControl]="formControl" appendTo="body"
              [showClear]="true" placeholder="-"></p-dropdown>
</div>
